export default __webpack_public_path__ + "static/media/title-customerIcon.2090de46.svg";